import { tipsList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Tips() {
  return (
    <section id="tips" className="w-full bg-background-50 px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="阅读小贴士"
          title="让追更这件事更轻松一点"
          desc="分类和筛选能帮你少走弯路，下面这几条习惯则能让长期阅读体验更稳定。"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {tipsList.map((tip) => (
            <article
              key={tip.title}
              className="rounded-lg border border-background-200 bg-background-100/70 p-5 hover:border-secondary-300 transition-colors"
            >
              <span className="w-11 h-11 rounded-lg flex items-center justify-center bg-secondary-100 text-secondary-700">
                <i className={`${tip.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{tip.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{tip.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}